/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import { StationEntity, StationCategoryEntity } from '../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function stations(backendAxiosInstance) {
  /**
   * @typedef GetStationsParams
   * @type {object}
   * @property {'es' | 'en' | 'pt' | '*'} [language]
   * @property {string} [region]
   * @property {number} [count]
   * @property {number} [offset]
   * @property {boolean} [entitlements]
   */
  /**
   * @param {GetStationsParams} [params]
   */
  async function getStations(params) {
    const response = await backendAxiosInstance.get('/content/v1/Stations', {
      params,
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, [StationEntity]);

    return response;
  }

  /**
   * @typedef GetStationByIdParams
   * @type {object}
   * @property {'es' | 'en' | 'pt'} [language]
   */
  /**
   * @param {string} stationId
   * @param {GetStationByIdParams} [params]
   */
  async function getStationById(stationId, params) {
    const response = await backendAxiosInstance.get(`/content/v1/Stations/${stationId}`, {
      params,
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, StationEntity);

    return response;
  }

  async function getStationCategories() {
    const response = await backendAxiosInstance.get('/content/v1/extensions/stations/categories', {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, [StationCategoryEntity]);

    return response;
  }

  /**
   * @param {number} categoryId
   */
  async function getStationsByCategory(categoryId) {
    const response = await backendAxiosInstance.get('/content/v1/extensions/stations', {
      params: { categoryId },
      authType: AuthType.SESSION_TOKEN,
    });

    const dataToNormalize = {
      id: categoryId,
      stations: response.data?.map(({ stationId }) => stationId),
    };

    response.normalizedData = normalize(dataToNormalize, StationCategoryEntity);

    return response;
  }

  return {
    getStations,
    getStationById,
    getStationCategories,
    getStationsByCategory,
  };
}
